import {
  FETCH_UNREAD_NOTIFICATIONS,
  FETCH_UNREAD_NOTIFICATIONS_SUCCESS,
  FETCH_DISMISSED_NOTIFICATIONS,
  FETCH_DISMISSED_NOTIFICATIONS_SUCCESS,
  FETCH_LATEST_NOTIFICATIONS,
  FETCH_LATEST_NOTIFICATIONS_SUCCESS,
  MARK_READ,
  MARK_ALL_SEEN,
  MARK_ALL_SEEN_SUCCESS,
  MARK_ALL_READ
} from './constants'

export const fetchUnreadNotifications = ({ page = 1, perPage = 10 } = {}) => ({
  type: FETCH_UNREAD_NOTIFICATIONS,
  payload: { page, perPage }
})

export const fetchUnreadNotificationsSuccess = (result) => ({
  type: FETCH_UNREAD_NOTIFICATIONS_SUCCESS,
  payload: result
})

export const fetchDismissedNotifications = ({ page = 1, perPage = 10 } = {}) => ({
  type: FETCH_DISMISSED_NOTIFICATIONS,
  payload: { page, perPage }
})

export const fetchDismissedNotificationsSuccess = (result) => ({
  type: FETCH_DISMISSED_NOTIFICATIONS_SUCCESS,
  payload: result
})

export const fetchLatestNotifications = () => ({
  type: FETCH_LATEST_NOTIFICATIONS
})

export const fetchLatestNotificationsSuccess = (result) => ({
  type: FETCH_LATEST_NOTIFICATIONS_SUCCESS,
  payload: result
})

export const markRead = ({ id, currentUnreadPage = 1, currentUnreadPerPage = 10, currentDismissedPage = 1, currentDismissedPerPage = 10 } = {}) => ({
  type: MARK_READ,
  payload: { id, currentUnreadPage, currentUnreadPerPage, currentDismissedPage, currentDismissedPerPage }
})

export const markAllRead = (ids = []) => ({
  type: MARK_ALL_READ,
  payload: { ids }
})

export const markAllSeen = (ids = []) => ({
  type: MARK_ALL_SEEN,
  payload: { ids }
})

export const markAllSeenSuccess = (ids = []) => ({
  type: MARK_ALL_SEEN_SUCCESS,
  payload: { ids }
})
